import { useMemo } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useFormatter } from 'js/hooks/useFormatter';

import { useDynamicReducerSelector } from '../../store';

export const useTransactions = () => {
    const formatter = useFormatter();
    const transactions = useDynamicReducerSelector(prop('transactions'));

    return useMemo(() => transactions.map(transaction => {
        let accountId;
        const {
            time, amount: { amount, currencyCode },
            methodCode, paymentAccountDetails, fee
        } = transaction;
        const { additionalPaymentsFields, cardSuffix } = paymentAccountDetails;

        if (additionalPaymentsFields?.length) {
            const accountIdField = additionalPaymentsFields.find(field => field.key === 'accountid');

            accountId = accountIdField ? accountIdField.value : additionalPaymentsFields[0].value;
        } else {
            accountId = cardSuffix || methodCode;
        }

        return {
            ...transaction,
            accountId,
            time: formatter.getLocaleDateShort(time),
            amount: formatter.formatCurrency(amount, { currencyCode }),
            fee: fee ? formatter.formatCurrency(fee.amount, { currencyCode: fee.currencyCode }) : ''
        };
    }), [formatter, transactions]);
};
